import "./jquery-global";
import { BaseMain } from "./BaseMain";
import "../resources/less/Admin/LoggedOut/ValidateEmailPage.less";
import LoginTriggerManager from "./Admin/LoginTriggerManager";
import { Container } from "./utils/DependencyInjection";

class LoggedOutMain extends BaseMain {
  constructor() {
    super();

    // This has to have a string token, because if Container.Get is called from another entrypoint,
    // it will evaluate as a different version of the same class.
    Container.Register("LoginTriggerManager", new LoginTriggerManager());
  }
}

$(window).on("load", () => {
  new LoggedOutMain();
});
